/** Initialen für den Profil-Avatar: Anfangsbuchstaben der ersten beiden Namensteile, großgeschrieben. */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  return parts
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join('')
}
